import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// messageType prop necessary to provide specific styles to the activity Error Message.
export const GenericMessageWrapper = styled.div<{
  messageType?: string;
}>(props => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',

  padding:
    props.messageType === 'activity'
      ? `${token('space.200')} ${token('space.100')} ${token('space.150')}`
      : `${token('space.300')} ${token('space.100')}`,

  textAlign: 'center',

  'p + button': {
    marginTop: token('space.100'),
  },
}));

export const GenericMessageHeader = styled.h5({
  font: token('font.heading.xsmall'),
  alignItems: 'center',
  display: 'flex',
});

export const GenericMessageTitle = styled.span({
  paddingLeft: token('space.050'),
  paddingRight: token('space.050'),
});
